import { render, staticRenderFns } from "./DebitCardNotificationModal.vue?vue&type=template&id=03dc8ab1&scoped=true"
import script from "./DebitCardNotificationModal.vue?vue&type=script&lang=js"
export * from "./DebitCardNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./DebitCardNotificationModal.vue?vue&type=style&index=0&id=03dc8ab1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dc8ab1",
  null
  
)

export default component.exports